module.exports = __webpack_public_path__ + "static/media/cert_62.5f227aaf.jpg";